import React, { Component } from "react";
// import "./index.css";
import { connect } from "react-redux";
import defaultImage from "../../../Images/dp.svg";
import axios from "axios";
import store from "store";
import MySnackbar from "../../../../Components/MyComponents/MySnackbar";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class SessionProfile extends Component {
  state = {
    sessionList: [],
    currentSession: store.get("session"),
    snackbar: false,
  };
  componentDidMount = () => {
    axios.get(`/api/cachedsession`).then((res) => {
      this.setState({ sessionList: res?.data });
    });
  };
  handleSession = (e) => {
    // console.log(e.target.value);
    let sessionObj = JSON.parse(e.target.value);

    // console.log(sessionObj, "asdfg");

    axios
      .get(
        `api/session_student?session=${sessionObj.id}&user=${this.props.user.id}`
      )
      .then((response) => {
        if (response.data.results.length > 0) {
          store.set("session", sessionObj);
          this.props.dispatch({
            type: "user/LOAD_CURRENT_ACCOUNT",
          });
        } else {
          this.setState({ snackbar: true });
        }
      })
      .catch((err) => {
        console.log(err, "errorrr");
        this.setState({ snackbar: true });

        // setTimeout(function () {
        //   window.location.reload(1);
        // }, 1500);
      });
  };
  render() {
    if (this.props.user.role.id === 9) {
      return (
        <React.Fragment>
          <div
            className="p-2 shadow-sm th-br-16 m-4 text-center"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
            }}
          >
            <div className="th-16 mb-1 th-white">Current Session</div>
            <select
              style={{
                background:
                  "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
              }}
              className="th-select th-br-12 p-1"
              name="session"
              id="session"
              onChange={(e) => this.handleSession(e)}
            >
              {this.state.sessionList?.map((eachSession, i) => {
                return (
                  <option
                    key={i}
                    value={JSON.stringify(eachSession)}
                    selected={
                      this.state.currentSession?.id === eachSession.id
                        ? "selected"
                        : ""
                    }
                  >
                    {" "}
                    {eachSession.session}
                  </option>
                );
              })}
            </select>
          </div>
          {this.state.snackbar ? (
            <MySnackbar title="You are not in the selected session" />
          ) : null}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div
            className="p-2 shadow-sm th-br-16 m-4 text-center"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
            }}
          >
            <div className="th-16 mb-1 th-white">Current Session</div>
            <select
              style={{
                background:
                  "linear-gradient(180deg, rgba(255, 255, 255, 0.42) 0%, rgba(255, 255, 255, 0.16) 100%)",
              }}
              className="th-select th-br-12 p-1"
              name="session"
              id="session"
              onChange={(e) => this.handleSession(e)}
            >
              {this.state.sessionList?.map((eachSession, i) => {
                return (
                  <option
                    key={i}
                    value={JSON.stringify(eachSession)}
                    selected={
                      this.state.currentSession?.id === eachSession.id
                        ? "selected"
                        : ""
                    }
                  >
                    {" "}
                    {eachSession.session}
                  </option>
                );
              })}
            </select>
          </div>
          {this.state.snackbar ? (
            <MySnackbar title="You are not in the selected session" />
          ) : null}
        </React.Fragment>
      );
    }
  }
}
export default connect(mapStateToProps)(SessionProfile);
